import { ReactNode } from "react";

import Typography from "../Typography";

type FeedbackHeadlineProps = {
  children?: ReactNode;
  className?: string;
};

const FeedbackHeadline = ({ className, children }: FeedbackHeadlineProps) => {
  return (
    <Typography tag="p" variant="p-t7" className={className}>
      {children}
    </Typography>
  );
};

FeedbackHeadline.displayName = "DS.Feedback.Headline";

export default FeedbackHeadline;
